import React, { useEffect, useRef, useState } from 'react';
import services from '../../services';
import { toast } from 'react-toastify';
import axios from 'axios';
import Automations from './Automations';
import DeletePopup from '../DeletePopup';
import AppModal from '../../common/AppModal';
import { FiZap, FiPlus, FiEdit2, FiTrash2, FiSearch, FiX, FiFilter } from 'react-icons/fi';
import AppSelect from '../../common/AppSelect';
import './AllAutomation.css';

const AllAutomation = ({ show, onHide, step, setStep, setAutomations, editId, setEditId }) => {
    const [automations, setAutomationsState] = useState([]);
    const [existautomation, setExistautomation] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [deletemodal, setDeletemodal] = useState(false);
    const [boardList, setBoardList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const [selectedType, setSelectedType] = useState('');
    const [selectedName, setSelectedName] = useState('');
    const [selectedGmailUserId, setSelectedGmailUserId] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedBoardId, setSelectedBoardId] = useState('');
    const [selectedListId, setSelectedListId] = useState('');
    const [showFilters, setShowFilters] = useState(false);

    // The service ignores abort signals, so an older (filtered) request can resolve
    // after a newer one (e.g. Clear) and overwrite it. Only the latest request may update state.
    const latestRequestId = useRef(0);

    const getAllAutomation = async (signal, filters) => {
        const requestId = ++latestRequestId.current;
        setLoading(true);
        try {
            const {
                type = selectedType,
                name = selectedName,
                gmailUserId = selectedGmailUserId,
                search = searchTerm,
                boardId = selectedBoardId,
                listId = selectedListId,
            } = filters || {};
            let query = `isColumnAutomation=false`;
            if (type) query += `&type=${type}`;
            if (name) query += `&name=${name}`;
            if (gmailUserId) query += `&gmailUserId=${gmailUserId}`;
            if (search) query += `&search=${encodeURIComponent(search)}`;
            if (boardId) query += `&boardId=${boardId}`;
            if (listId) query += `&boardListId=${listId}`;

            const response = await services.automations.GET_ALL_AUTOMATIONS(query, { signal });
            if (requestId !== latestRequestId.current) return;

            // an empty list comes back as [] (truthy), a missing body as undefined
            setAutomationsState(response || []);
            if (response?.length > 0) {
                setExistautomation(true);
            }
        } catch (e) {
            if (e.name === 'AbortError' || e.name === 'CanceledError') return;
            if (requestId !== latestRequestId.current) return;
            toast.error('Failed to fetch automations');
            setAutomationsState([]);
        }
        if (requestId === latestRequestId.current) setLoading(false);
    };

    useEffect(() => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            getAllAutomation(controller.signal);
        }, 500);
        return () => {
            clearTimeout(timeoutId);
            controller.abort();
        };
    }, [searchTerm]);

    const handleClear = () => {
        setSelectedType('');
        setSelectedName('');
        setSelectedGmailUserId('');
        setSearchTerm('');
        setSelectedBoardId('');
        setSelectedListId('');
        // state updates are async, so pass the cleared values explicitly
        getAllAutomation(undefined, {
            type: '',
            name: '',
            gmailUserId: '',
            search: '',
            boardId: '',
            listId: '',
        });
    };

    useEffect(() => {
        const getUserById = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser`);
                if (response?.data?.data?.users) {
                    setUserList(response?.data?.data?.users);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };

        const getGmailUsers = async () => {
            try {
                const response = await services.email.Get_The_Linked_Email();
                if (response?.data) {
                    const gmailOptions = response.data.map((item) => ({
                        value: item.id,
                        label: item.email,
                    }));
                    setFilterList(gmailOptions);
                }
            } catch (error) {
                console.error('Error fetching Gmail users:', error);
            }
        };

        getUserById();
        getGmailUsers();
        getAllBoardDateTable();
    }, []);

    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            if (response) {
                setBoardList(response?.data?.data);
                const boardNameOptions =
                    response?.data?.data?.map((board) => ({
                        label: board.boardName,
                        value: board.id,
                    })) || [];
                setBoardName(boardNameOptions);
                const boardColumnsMap = {};
                response?.data?.data?.forEach((board) => {
                    if (board.BoardLists && board.BoardLists.length > 0) {
                        boardColumnsMap[board.id] = board.BoardLists.map((column) => ({
                            id: column.id,
                            name: column.coloum,
                            color: column.colour,
                            sequence: column.sequence,
                        }));
                    }
                });
                setColumnList(boardColumnsMap);
            }
        } catch (error) {
            console.error('Error fetching board date table:', error);
        }
    };

    const getUserNameById = (id) => {
        const user = userList.find((u) => u.id === id);
        return user ? user.name : 'N/A';
    };

    const getBoardNameById = (id) => {
        const board = boardList.find((b) => b.id === id);
        return board ? board.boardName : 'N/A';
    };

    const getColumnNameById = (boardId, columnId) => {
        if (columnList[boardId]) {
            const column = columnList[boardId].find((col) => col.id === columnId);
            return column ? column.name : 'N/A';
        }
        return 'N/A';
    };

    const getColumnsByBoardId = (boardId) => {
        return columnList[boardId] || [];
    };

    const getBoardIdFromAutomation = (auto) => {
        if (auto.type === 'new') {
            const createOnListAction = auto.action?.find((action) => action.action === 'createOnList');
            return createOnListAction?.boardId;
        }
        return auto.condition?.find((c) => c.operand === 'board')?.value;
    };

    const handleEdit = (id) => {
        setStep(2);
        setAutomations(true);
        setEditId(id);
    };

    const handleDelete = (id) => {
        setDeleteId(id);
        setDeletemodal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            await services.automations.DELETE_BY_ID_AUTOMATIONS(deleteId);
            toast.success('Automation deleted successfully');
            setDeletemodal(false);
            setDeleteId(null);
            getAllAutomation();
        } catch (e) {
            toast.error('Failed to delete automation');
        }
    };

    const formatConditions = (conditions = [], boardList = [], columnList = {}, automationType = '', gmailUserId = '') => {
        if (!Array.isArray(conditions) || conditions.length === 0) return [];
        const formattedConditions = conditions.map((cond) => {
            let label = '';
            let value = cond.value;
            switch (cond.operand) {
                case 'title': label = 'Title'; break;
                case 'listName':
                    label = 'List';
                    for (const boardId in columnList) {
                        const column = columnList[boardId]?.find((col) => col.id === cond.value);
                        if (column) { value = column.name; break; }
                    }
                    break;
                case 'board':
                    label = 'Board';
                    const board = boardList.find((b) => b.id === cond.value);
                    if (board) value = board.boardName;
                    break;
                case 'assignee':
                    label = 'Assignee';
                    if (Array.isArray(cond.value)) {
                        const userIds = cond.value.map((item) => item.entityId).filter(Boolean);
                        value = userIds.map((userId) => getUserNameById(userId)).join(', ');
                    } else if (cond.value && typeof cond.value === 'object' && cond.value.entityId) {
                        value = getUserNameById(cond.value.entityId);
                    } else if (typeof cond.value === 'string') {
                        value = getUserNameById(cond.value);
                    }
                    break;
                case 'subject': label = 'Subject'; break;
                case 'sender': label = 'From email address'; break;
                case 'recipient': label = 'To email address'; break;
                case 'customerWaiting': label = 'the customer has been waiting'; break;
                case 'customerNotResponding': label = 'the team has been waiting'; break;
                default: label = cond.operand;
            }
            let operatorText = '';
            switch (cond.operator) {
                case 'equals': operatorText = 'equals'; break;
                case 'doesNotContain': operatorText = 'does not contain'; break;
                case 'contains': operatorText = 'contains'; break;
                case 'moreThanMins': operatorText = 'more than (minutes)'; break;
                case 'moreThanHrs': operatorText = 'more than (hours)'; break;
                case 'moreThanDays': operatorText = 'more than (days)'; break;
                default: operatorText = cond.operator;
            }
            return `${label} ${operatorText} "${value}"`;
        });
        if (automationType === 'new' && gmailUserId) {
            const gmailUser = filterList.find((user) => user.value === gmailUserId);
            if (gmailUser) formattedConditions.unshift(gmailUser.label);
        }
        return formattedConditions.join(', ');
    };

    // Ticket priority: which lists of the board the rule orders
    const priorityListsText = (auto) => {
        const when = typeof auto?.when === 'string' ? (() => { try { return JSON.parse(auto.when); } catch (e) { return {}; } })() : auto?.when;
        const ids = Array.isArray(when?.boardListIds) ? when.boardListIds.filter(Boolean) : [];
        if (!ids.length) return 'Lists: all lists without their own priority';
        return `Lists: ${ids.map((id) => getColumnNameById(when.boardId, id)).join(', ')}`;
    };

    const formatActions = (actions = [], auto = null) => {
        if (!Array.isArray(actions) || actions.length === 0) return [];
        if (auto?.type === 'ticketPriority' && actions.some((a) => a?.listId)) {
            // different order for each list: "To Do (2 priorities), In Progress (1 priority)"
            const when = typeof auto.when === 'string' ? (() => { try { return JSON.parse(auto.when); } catch (e) { return {}; } })() : auto.when;
            const counts = new Map();
            actions.filter((a) => a?.listId).forEach((a) => counts.set(a.listId, (counts.get(a.listId) || 0) + 1));
            return `Each list its own order: ${[...counts]
                .map(([id, n]) => `${getColumnNameById(when?.boardId || actions[0]?.boardId, id)} (${n} ${n === 1 ? 'priority' : 'priorities'})`)
                .join(', ')}`;
        }
        const text = formatActionTexts(actions);
        return auto?.type === 'ticketPriority' ? `${priorityListsText(auto)}, ${text}` : text;
    };

    const formatActionTexts = (actions) => {
        return actions.map((act) => {
            switch (act.action) {
                case 'createOnList':
                    return `Create task on list: ${getColumnNameById(act.boardId, act.entityId)}`;
                case 'assignTo':
                    return `Assign to ${getUserNameById(act.entityId)}`;
                case 'assignToRoundRobin':
                    if (act.entityIds && Array.isArray(act.entityIds)) {
                        return `Assign with round robin to ${act.entityIds.map((u) => getUserNameById(u.entityId)).join(', ')}`;
                    }
                    return act.entityId ? `Assign with round robin to ${getUserNameById(act.entityId)}` : 'Assign with round robin';
                case 'unassign': return 'Unassign task';
                case 'markComplete': return 'Mark task as complete';
                case 'markIncomplete': return 'Mark task as incomplete';
                case 'moveToNext': return 'Move task to next list';
                case 'moveToPreviousList': return 'Move task to previous list';
                case 'sendOverdueAlert': return act.message ? `Send overdue alert: "${act.message}"` : 'Send overdue alert';
                case 'sendFollowUpToCustomer':
                    return act.templateHtml ? `Create Follow-up Reminder: "${act.templateHtml.replace(/<[^>]*>/g, '')}"` : 'Create Follow-up Reminder';
                case 'sendUpcomingAlert': return act.message ? `Send upcoming alert: "${act.message}"` : 'Send upcoming alert';
                case 'sendNotificationTo': return act.entityId ? `Send notification to ${getUserNameById(act.entityId)}` : 'Send notification';
                case 'setSlaAlertTag': return act.entityValue && Array.isArray(act.entityValue) ? `Set SLA Alert Tag: ${act.entityValue.join(', ')}` : 'Set SLA Alert Tag';
                case 'setTripStatus': return `Set trip status: ${act.tripStatus}`;
                case 'moveToList': return `Move to list: ${getColumnNameById(act.boardId, act.boardListId)}`;
                case 'processStep':
                    return `${Number(act.order ?? 0) + 1}. ${getColumnNameById(act.boardId, act.listId)} (${act.mandatory === false ? 'optional' : 'mandatory'})`;
                case 'priorityLevel': {
                    const count = Array.isArray(act.customFieldIds) ? act.customFieldIds.length : 0;
                    return `Priority ${Number(act.order ?? 0) + 1}: ${count} status${count === 1 ? '' : 'es'}`;
                }
                case 'subEmailInbox': return 'Skip inbox processing';
                case 'emailInbox': return act.hasReply !== undefined ? `Email inbox (hasReply: ${act.hasReply === true ? 'skip' : 'not skip'})` : 'Email inbox';
                default: return act.action;
            }
        }).join(', ');
    };

    const typeLabelMap = {
        itemAdded: 'Item Added to List',
        new: 'New Email Received',
        noReplyFromCustomer: 'No Reply From Customer',
        noReplyToCustomer: 'No Reply To Customer',
        propertyStatusLink: 'Property Status Link',
        listProcess: 'Ticket Process',
        ticketPriority: 'Ticket Priority',
        default: 'Unknown Type',
    };

    const hasActiveFilters = selectedType || selectedGmailUserId || searchTerm || selectedBoardId || selectedListId;

    const visibleAutomations = automations;

    return (
        <>
            <AppModal
                show={show}
                onClose={onHide}
                icon={<FiZap size={17} color="#fff" />}
                title="Automations"
                subtitle="Manage your workflow automations"
                maxWidth="920px"
                footer={
                    <button
                        className="btn-primary-green"
                        onClick={() => {
                            setStep(2);
                            setEditId(null);
                            setAutomations(true);
                        }}
                    >
                        <FiPlus size={14} />
                        Create Automation
                    </button>
                }
            >
                {/* ── Filter bar ── */}
                <div className="aa-filter-bar">
                    <div className="aa-search-wrapper">
                        <span className="aa-search-icon">
                            <FiSearch size={14} />
                        </span>
                        <input
                            type="text"
                            placeholder="Search automations..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="aa-search-input"
                        />
                    </div>

                    <button
                        className="btn-primary-green"
                        onClick={() => setShowFilters((prev) => !prev)}
                    >
                        <FiFilter size={14} />
                        Filter
                    </button>
                </div>

                {showFilters && (
                    <div className="aa-filter-bar">
                        <AppSelect
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                            placeholder="All Types"
                            options={[
                                { value: '', label: 'All Types' },
                                { value: 'itemAdded', label: 'Item Added to List' },
                                { value: 'new', label: 'New Email Received' },
                                { value: 'noReplyFromCustomer', label: 'No Reply From Customer' },
                                { value: 'noReplyToCustomer', label: 'No Reply To Customer' },
                                { value: 'propertyStatusLink', label: 'Property Status Link' },
                                { value: 'listProcess', label: 'Ticket Process' },
                                { value: 'ticketPriority', label: 'Ticket Priority' },
                            ]}
                        />

                        <AppSelect
                            value={selectedGmailUserId}
                            onChange={(e) => setSelectedGmailUserId(e.target.value)}
                            className="aa-select--wide"
                            placeholder="All Emails"
                            options={[
                                { value: '', label: 'All Emails' },
                                ...filterList,
                            ]}
                        />

                        <AppSelect
                            value={selectedBoardId}
                            onChange={(e) => {
                                setSelectedBoardId(e.target.value);
                                setSelectedListId('');
                            }}
                            placeholder="All Boards"
                            options={[
                                { value: '', label: 'All Boards' },
                                ...boardName,
                            ]}
                        />

                        <AppSelect
                            value={selectedListId}
                            onChange={(e) => setSelectedListId(e.target.value)}
                            placeholder="All Lists"
                            options={[
                                { value: '', label: 'All Lists' },
                                ...getColumnsByBoardId(selectedBoardId).map((col) => ({ value: col.id, label: col.name })),
                            ]}
                        />

                        <button
                            className="btn-primary-green"
                            onClick={() => getAllAutomation()}
                        >
                            Add Filter
                        </button>

                        {hasActiveFilters && (
                            <button
                                className="aa-btn-reset"
                                onClick={handleClear}
                            >
                                <FiX size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                )}

                {/* ── Table ── */}
                <div className="data-table-card">
                    <div className="data-table-scroll">
                        <table className="data-table">
                            {visibleAutomations.length > 0 && (
                                <thead>
                                    <tr className="data-table__head-row">
                                        <th className="data-table__th" style={{ width: '14%' }}>Board</th>
                                        <th className="data-table__th" style={{ width: '18%' }}>Type</th>
                                        <th className="data-table__th" style={{ width: '28%' }}>Conditions</th>
                                        <th className="data-table__th" style={{ width: '28%' }}>Actions</th>
                                        <th className="data-table__th" style={{ width: '12%' }}></th>
                                    </tr>
                                </thead>
                            )}
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={5} className="loader-cell">
                                            <div className="loader-inner">
                                                <div className="loader-spinner" />
                                                <span className="loader-text">Loading automations…</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : visibleAutomations.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <div className="empty-state">
                                                <FiZap size={40} color="#d1d5db" />
                                                <p className="empty-state__text">No automations yet — create your first one</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    visibleAutomations.map((auto) => (
                                        <tr key={auto.id} className="data-table__row">
                                            <td className="data-table__td data-table__td--badge">
                                                <span
                                                    className="badge-board"
                                                    title={getBoardNameById(getBoardIdFromAutomation(auto))}
                                                >
                                                    {getBoardNameById(getBoardIdFromAutomation(auto))}
                                                </span>
                                            </td>
                                            <td className="data-table__td data-table__td--badge">
                                                <span
                                                    className="badge-type"
                                                    title={typeLabelMap[auto.type] || typeLabelMap.default}
                                                >
                                                    {typeLabelMap[auto.type] || typeLabelMap.default}
                                                </span>
                                            </td>
                                            <td className="data-table__td--muted">
                                                <span
                                                    className="truncate-cell"
                                                    title={formatConditions(auto.condition, boardList, columnList, auto.type, auto.when?.gmailUserId)}
                                                >
                                                    {formatConditions(auto.condition, boardList, columnList, auto.type, auto.when?.gmailUserId) || '—'}
                                                </span>
                                            </td>
                                            <td className="data-table__td--muted">
                                                <span
                                                    className="truncate-cell"
                                                    title={formatActions(auto.action, auto)}
                                                >
                                                    {formatActions(auto.action, auto) || '—'}
                                                </span>
                                            </td>
                                            <td className="data-table__td data-table__td--right">
                                                <div className="action-group">
                                                    <button
                                                        className="btn-icon-edit"
                                                        title="Edit automation"
                                                        onClick={() => handleEdit(auto.id)}
                                                    >
                                                        <FiEdit2 size={13} />
                                                    </button>
                                                    <button
                                                        className="btn-icon-delete"
                                                        title="Delete automation"
                                                        onClick={() => handleDelete(auto.id)}
                                                    >
                                                        <FiTrash2 size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </AppModal>

            {automations && step === 2 && (
                <Automations
                    show={automations}
                    setAutomations={setAutomations}
                    onHide={onHide}
                    boardName={boardName}
                    gmailUsers={filterList}
                    step={step}
                    setStep={setStep}
                    editId={editId}
                    setEditId={setEditId}
                    getAllAutomation={getAllAutomation}
                />
            )}

            <DeletePopup
                open={deletemodal}
                title="Are you sure you want to delete this automation?"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletemodal(false)}
                confirmLabel="YES, I'M SURE"
                cancelLabel="NO"
            />
        </>
    );
};

export default AllAutomation;
